// extracted by mini-css-extract-plugin
export var hidden = "_o0-1";
export var visible = "_o0-0";